import spinnerIcon from './spinner.png';

export default function ModalLoadingContent({ text }: { text?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-5 rounded-lg bg-card p-8 shadow-md w-84.25 max-md:w-full">
      <div className="relative w-21 h-21">
        <div
          className="absolute w-17.5 h-17.5 top-1.75 left-1.75 bg-cover animate-spin"
          style={{
            backgroundImage: `url(${spinnerIcon})`,
            animationDuration: '0.6s',
          }}
        />
      </div>
      {text && <div className="text-foreground text-base">{text}</div>}
    </div>
  );
}
